export default function ArtifactsPage() {
  return (
    <div className="animate-fade-in py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="font-display text-4xl sm:text-5xl text-archive-cream">
            Archive Artifacts
          </h1>
          <p className="mt-4 text-lg text-archive-muted max-w-2xl mx-auto">
            Museum-quality prints, medallions, and seals from across the archives.
          </p>
        </div>

        {/* Coming Soon */}
        <div className="relative rounded-2xl border border-archive-ash/30 bg-archive-charcoal/50 p-12 sm:p-16 text-center">
          <div className="flex flex-col items-center justify-center">
            <svg className="w-20 h-20 text-archive-gold/50" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
            <h2 className="mt-6 font-display text-2xl sm:text-3xl text-archive-cream">
              Archive Shop
            </h2>
            <p className="mt-4 text-archive-muted max-w-lg">
              We're curating a collection of premium prints, medallions, and collectibles
              from across the archives. Each piece tells a story from humanity's collective memory.
            </p>
            <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-archive-gold/30 bg-archive-gold/10 px-6 py-3">
              <div className="h-2 w-2 animate-pulse rounded-full bg-archive-gold" />
              <span className="text-sm uppercase tracking-wider text-archive-gold">Coming Soon</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
